// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_5FDei","nyh_share--article":"_243P6","nyh_share--story":"_2r-9S"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Sharebuttons/Sharebuttons.scss
 ** module id = 462
 ** module chunks = 0
 **/